import IntroComponent from "./IntroComponent";

const Intro = () => {
	return (
		<section className="section" id="intro">
				<IntroComponent src="/images/sfr-intro.png" />
		</section>
	);
};

export default Intro;
